import { ActionReducerMap } from '@ngrx/store';
import { IState } from './csat.declarations';
import { CsatReducer } from './csat.reducer';

export interface CsatPartialState {
  csat: IState
}

export const reducer: ActionReducerMap<CsatPartialState> = {
  csat: CsatReducer
}
